import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/modal/Modal'
import ModalButton from 'components/modal/ModalButton'
import LoginContent from 'components/modal/LoginContent'

const LoginModal = props => {
  const { onCloseClick, onLoginClick, ...rest } = props

  return (
    <Modal
      {...rest}
      cancellable
      spaceBottom
      onClose={onCloseClick}
      onOutClick={onCloseClick}
      actions={[
        <ModalButton
          key="login"
          testId="login"
          title="Login"
          onClick={onLoginClick}
        />
      ]}
    >
      <LoginContent />
    </Modal>
  )
}

LoginModal.propTypes = {
  onCloseClick: PropTypes.func,
  onLoginClick: PropTypes.func
}

LoginModal.defaultProps = {
  onCloseClick: () => () => {},
  onLoginClick: () => () => {}
}

export default LoginModal



// WEBPACK FOOTER //
// ./src/components/modal/LoginModal.js